import { render, staticRenderFns } from "./addedit-country.vue?vue&type=template&id=1b904f61"
import script from "./addedit-country.vue?vue&type=script&lang=js"
export * from "./addedit-country.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports